<template>
  <div>
    <a-card class="customer-filter" size="small">
      <a-page-header>
        <a-form-model :form="filterForm" :label-col="{ span: 6 }" :model="filterForm" class="search-form">
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item label="名称">
                <a-input v-model="filterForm.name" allow-clear placeholder="用例名称" class="form-model-item" @change="onSearch('name')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="状态">
                <a-select v-model="filterForm.status" mode="multiple" allow-clear placeholder="状态" @change="onSearch('status')">
                  <a-select-option v-for="(item, index) in caseStatus" :key="index" :value="item.value">
                    <a-tag :color="item.color">{{ item.label }}</a-tag>
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item v-show="expand" label="优先级">
                <a-select v-model="filterForm.priority" mode="multiple" allow-clear placeholder="优先级" @change="onSearch('priority')">
                  <a-select-option v-for="(item, index) in casePrioritys" :key="index" :value="item.value">
                    <a-tag :color="item.color"> {{ item.label }} </a-tag>
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item v-show="expand" label="创建人">
                <user-select v-model="filterForm.creator" :project-id="projectId" mode="multiple" show-search placeholder="创建人" allow-clear @change="onSearch('creator')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item v-show="expand" label="需求">
                <a-select v-model="requirement" show-search label-in-value style="width: 100%" :filter-option="false" :not-found-content="requirementSearching ? undefined : null" @search="searchRequirement" @change="onSearch">
                  <a-spin v-if="requirementSearching" slot="notFoundContent" size="small" />
                  <a-select-option v-for="item in searchRequirementData" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item v-show="expand" label="标签">
                <a-select v-model="filterForm.tags" mode="multiple" allow-clear placeholder="标签" @change="onSearch">
                  <a-select-option v-for="(item, index) in tagData" :key="index" :value="item.id">{{ item.name }} </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="16">
              <a-form-model-item v-show="expand" label="时间筛选" :label-col="{ span: 3 }">
                <a-input-group compact>
                  <a-select v-model="filterForm.time_filter" style="width: 30%" @change="onSearch">
                    <a-select-option value="created_time"> 创建时间 </a-select-option>
                    <a-select-option value="updated_time"> 更新时间 </a-select-option>
                  </a-select>
                  <a-date-picker v-model="filterForm.start_time" style="width: 35%" placeholder="开始时间" value-format="YYYY-MM-DD" @change="onSearch" />
                  <a-date-picker v-model="filterForm.end_time" style="width: 35%" placeholder="结束时间" value-format="YYYY-MM-DD" @change="onSearch" />
                </a-input-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item v-show="expand" label="优质用例">
                <a-select v-model="filterForm.premium" allow-clear placeholder="优质用例" @change="onSearch('premium')">
                  <a-select-option v-for="(item, index) in casePremiums" :key="index" :value="item.value">
                    <a-tag :color="item.color"> {{ item.label }} </a-tag>
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8" style="float: right; text-align: right">
              <a-button v-tc="{ name: '查询' }" type="primary" @click="getCaseList">查询</a-button>
              <a-button v-tc="{ name: '重置' }" :style="{ margin: '0 8px' }" @click="reset">重置</a-button>
              <a v-tc="{ name: '展开/收起' }" class="ant-dropdown-link" @click="expand = !expand">{{ expand ? '收起' : '展开' }} <a-icon :type="expand ? 'up' : 'down'" /> </a>
            </a-col>
          </a-row>
        </a-form-model>
      </a-page-header>
    </a-card>
    <a-card title="用例列表" size="small" class="filter-data">
      <span slot="extra">
        <!-- 用例批量修改 -->
        <a-tooltip title="勾选用例后，一键分享">
          <a-button v-tc="{ name: '分享' }" type="primary" class="handle-button" icon="share-alt" @click="onShare" />
        </a-tooltip>
        <case-batch-edit class="handle-button" :checked="selectedRowKeys" @close="getCaseList" />
        <!-- 用例批量删除 -->
        <case-batch-delete class="handle-button" :checked="selectedRowKeys" @close="getCaseList" />
        <!-- 用例导入 -->
        <case-import class="handle-button" :module-id="filterForm.module_id" @close="close" />
        <a-tooltip title="导出">
          <a-button v-tc="{ name: '导出' }" type="primary" class="handle-button" icon="export" @click="onExport" />
        </a-tooltip>
        <a-tooltip title="添加">
          <a-button v-tc="{ name: '添加' }" type="primary" class="handle-button" icon="plus" @click="onAdd" />
        </a-tooltip>
      </span>
      <a-table :scroll="{ x: 1300 }" :pagination="pagination" :columns="columns" :data-source="tableData" :loading="loading" row-key="id" :row-selection="showRowSelection" @change="handleTableChange">
        <span slot="name" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.name">
            <a v-tc="{ name: '查看用例详情' }" class="custom-link" @click="onDetail(record)"> {{ record.name }} </a>
          </a-tooltip>
        </span>
        <span slot="action" slot-scope="text, record">
          <a-dropdown placement="bottomCenter">
            <a-icon type="more" />
            <a-menu slot="overlay">
              <a-menu-item>
                <a v-tc="{ name: '编辑' }" class="ant-dropdown-link" @click="onEdit(record)"><a-icon type="edit" /> 编辑</a>
              </a-menu-item>
              <a-menu-item>
                <a v-tc="{ name: '删除' }" class="ant-dropdown-link" @click="onDelete(record)"><a-icon type="delete" /> 删除</a>
              </a-menu-item>
              <a-menu-item>
                <a v-tc="{ name: '复制' }" class="ant-dropdown-link" @click="onCaseCopy(record)"><a-icon type="copy" /> 复制</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
        <span slot="priority" slot-scope="text, record">
          <span v-if="record.priority !== null && record.priority !== undefined"> {{ casePrioritys[record.priority].label }} </span>
          <span v-else>--</span>
        </span>
        <span slot="premium" slot-scope="text, record">
          <case-premium-edit :value="record.premium" :case-id="record.id" @change="getCaseList" />
        </span>
        <span slot="status" slot-scope="text, record">
          <span v-if="record.status">{{ caseStatus[record.status].label }}</span>
          <span v-else>--</span>
        </span>
        <span slot="tags" slot-scope="text, record">
          <a-popover placement="topLeft">
            <template slot="content">
              <a-tag v-for="(tag, index) in record.tags" :key="index" color="blue">{{ tag.name }}</a-tag>
            </template>
            <template slot="title">
              <span>用例标签</span>
            </template>
            <a-tag v-for="(tag, index) in record.tags" :key="index" color="blue">{{ tag.name }}</a-tag>
          </a-popover>
        </span>
        <span slot="creator" slot-scope="text, record"><user-profiles :value="[record.creator.id]" avatar /></span>
      </a-table>
    </a-card>
    <case-drawer ref="caseDrawerRef" @next="next" @back="back" @callback="getCaseList" />
  </div>
</template>
<script>
import { onCopy } from '@/utils/utils';
import { tagList } from '@/api/system/tag';
import { storySearch } from '@/api/project/story';
import { caseStatus, casePrioritys, casePremiums } from '@/utils/dictionary';
import { caseDelete, caseExport, caseList, caseCopy } from '@/api/project/case';

import UserSelect from '@/components/User/UserSelect';
import CaseImport from '@/pages/project/case/components/CaseImport';
import CaseDrawer from '@/pages/project/case/components/CaseDrawer';
import CaseBatchEdit from '@/pages/project/case/components/CaseBatchEdit';
import CasePremiumEdit from '@/pages/project/case/components/CasePremiumEdit';
import CaseBatchDelete from '@/pages/project/case/components/CaseBatchDelete';

const columns = [
  {
    width: 32,
    key: 'action',
    align: 'center',
    fixed: true,
    scopedSlots: { customRender: 'action' }
  },
  {
    title: 'ID',
    dataIndex: 'key',
    key: 'key',
    width: 100,
    ellipsis: true
  },
  {
    title: '名称',
    width: 400,
    ellipsis: true,
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '优先级',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'priority' }
  },
  {
    title: '标签',
    width: 200,
    scopedSlots: { customRender: 'tags' }
  },
  {
    title: '状态',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '优质用例',
    width: 90,
    scopedSlots: { customRender: 'premium' }
  },
  {
    title: '创建人',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'creator' }
  },
  {
    title: '创建时间',
    width: 170,
    align: 'center',
    dataIndex: 'created_time',
    key: 'created_time'
  },
  {
    title: '更新时间',
    width: 170,
    align: 'center',
    dataIndex: 'updated_time',
    key: 'updated_time'
  }
];

function queryParamsHandler(item, needParseInt = true) {
  if (typeof item === 'undefined' || item.length === 0) {
    return [];
  } else if (item.length === 1) {
    return needParseInt ? [parseInt(item)] : [item];
  } else {
    return needParseInt ? item.map(i => parseInt(i)) : item;
  }
}

function RemoveUrlParam(name) {
  var location = window.location;
  var baseUrl = location.origin + location.pathname + '?';
  var query = location.search.substr(1);
  if (query.indexOf(name) > -1) {
    var obj = {};
    var arr = query.split('&');
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split('=');
      obj[arr[i][0]] = arr[i][1];
    }
    delete obj[name];
    var url =
      baseUrl +
      JSON.stringify(obj)
        .replace(/[\"\{\}]/g, '')
        .replace(/\:/g, '=')
        .replace(/\,/g, '&');
    return url;
  }
}

export default {
  components: { UserSelect, CaseImport, CaseDrawer, CaseBatchEdit, CaseBatchDelete, CasePremiumEdit },
  data() {
    return {
      columns,
      caseStatus,
      casePremiums,
      casePrioritys,
      tagData: [],
      expand: true,
      caseId: null,
      caseData: {},
      tableData: [],
      loading: false,
      requirement: {},
      editVisible: false,
      selectedRowKeys: [],
      detailVisible: false,
      searchRequirementData: [],
      requirementSearching: false,
      projectId: parseInt(this.$route.params.project_id) || null,
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: 20, // 每页中显示20条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      sorter: {},
      filterForm: {
        name: this.$route.query.name || null,
        status: queryParamsHandler(this.$route.query.status),
        priority: queryParamsHandler(this.$route.query.priority),
        // creator: queryParamsHandler(this.$route.query.creator),
        time_filter: 'created_time',
        module_id: typeof this.$route.query.module_id === 'undefined' ? -1 : parseInt(this.$route.query.module_id),
        id_list: this.$route.query.id_list ? this.$route.query.id_list.split(',').map(id => parseInt(id)) : null
      }
    };
  },
  computed: {
    caseLink() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:project:quality:case:detail',
          query: { issueId: record.id }
        });
        return route.href;
      };
    },
    showRowSelection() {
      return { columnWidth: 28, fixed: true, selectedRowKeys: this.selectedRowKeys, onChange: this.onSelectChange };
    },
    // 获取总页数
    pageTotal() {
      try {
        return parseInt((this.pagination.total - 1) / this.pagination.pageSize + 1);
      } catch (e) {
        return 0;
      }
    }
  },
  created() {
    this.getTagList();
    this.getCaseList();
  },
  methods: {
    // 获取标签列表
    getTagList() {
      tagList({ group_code: 'case' }).then(res => {
        this.tagData = res.data.items;
      });
    },

    // 设置筛选模块
    setSelectModule(keys) {
      this.filterForm.module_id = keys[0];
      // 更新路径参数
      const customerQuery = { ...this.$route.query };
      delete customerQuery['id_list'];
      this.filterForm.id_list = null;
      this.$set(customerQuery, 'module_id', this.filterForm.module_id);
      this.$router.push({ query: customerQuery });

      this.pagination.current = 1;
      this.pagination.pageSize = 20;
      this.getCaseList();
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },

    searchRequirement(value) {
      storySearch({ project_id: this.projectId, value: value }).then(res => {
        this.searchRequirementData = res.data.items;
      });
    },

    // 获取用例列表
    async getCaseList() {
      this.loading = true;
      this.selectedRowKeys = [];
      if (this.requirement && this.requirement.key) {
        this.filterForm.requirement_id = this.requirement.key;
      }
      const { code, message, data } = await caseList({ project_id: this.projectId, ...this.filterForm, page_size: this.pagination.pageSize, page_number: this.pagination.current });
      if (code === 2000) {
        this.tableData = data.items;
        this.pagination.total = data.total;
        this.loading = false;
      } else {
        console.error(message);
        this.loading = false;
      }
    },
    onCaseCopy(record) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要复制这条用例吗',
        okText: '确定',
        okType: 'primary',
        cancelText: '取消',
        onOk() {
          caseCopy({ case_id: record.id, project_id: self.projectId }).then(() => {
            self.$message.success('复制成功');
            self.getCaseList();
          });
        }
      });
    },
    // 删除用例
    onDelete(record) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除这条用例吗',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          caseDelete({ id: record.id, project_id: self.projectId }).then(() => {
            self.getCaseList();
            self.$message.success('删除成功');
          });
        }
      });
    },
    onShare() {
      let joinChar = '?';
      if (window.location.href.indexOf('?') !== -1) {
        joinChar = '&';
      }
      let url = window.location.href;
      if (window.location.href.indexOf('id_list') !== -1) {
        url = RemoveUrlParam('id_list');
      }
      const shareUrl = url + joinChar + 'id_list=' + this.selectedRowKeys.join(',');
      onCopy(shareUrl);
    },
    // 导出用例
    onExport() {
      const self = this;
      this.$confirm({
        title: '用例导出确认',
        content: '确认导出当前用例吗',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          caseExport({ project_id: self.projectId, ...self.filterForm }).then(res => {
            const filename = res.headers['content-disposition'];
            const blob = new Blob([res.data]);
            const element = document.createElement('a');
            const href = window.URL.createObjectURL(blob); // 创建下载的链接
            element.href = href;
            element.download = decodeURI(filename.match(/filename=(\S*);/)[1]);
            document.body.appendChild(element);
            element.click(); // 点击下载
            document.body.removeChild(element); // 下载完成移除元素
            window.URL.revokeObjectURL(href); // 释放掉blob对象
            self.$message.success('开始下载，请耐心等待！');
          });
        }
      });
    },

    // 重置查询
    reset() {
      this.filterForm = {
        time_filter: 'created_time',
        module_id: this.filterForm.module_id
      };
      this.pagination.current = 1;
      this.pagination.pageSize = 20;
      this.requirement = {};
      this.$router.push({
        query: { module_id: this.filterForm.module_id }
      });
      this.getCaseList();
    },

    checkItemEmpty(item) {
      return typeof item === 'undefined' || item === '' || item.length === 0;
    },
    // 搜索
    onSearch(item = null) {
      const customerQuery = { ...this.$route.query };
      const supportedFieldsToShare = ['name', 'status', 'priority'];
      if (supportedFieldsToShare.includes(item) && this.checkItemEmpty(this.filterForm[item])) {
        if (item === 'name') {
          this.$set(this.filterForm, item, null);
        } else {
          this.$set(this.filterForm, item, []);
        }
        delete customerQuery[item];
      } else if (supportedFieldsToShare.includes(item)) {
        this.$set(customerQuery, item, this.filterForm[item]);
      }
      this.$set(customerQuery, 'module_id', this.filterForm.module_id);
      this.$router.push({ query: customerQuery });

      this.pagination.current = 1;
      this.pagination.pageSize = 20;
      this.getCaseList();
    },

    async next(caseId) {
      const caseIndex = this.getCaseIndex(caseId);
      if (caseIndex !== null && caseIndex < this.tableData.length - 1) {
        this.onDetail(this.tableData[caseIndex + 1]);
      } else {
        // 这里证明要翻页，先判断是不是最后一页
        if (this.pagination.current < this.pageTotal) {
          this.pagination.current = this.pagination.current + 1;
          await this.getCaseList();
          setTimeout(() => {
            this.onDetail(this.tableData[0]);
          }, 100);
        } else {
          console.log('已经是最后一页了，别翻了');
        }
      }
    },

    getCaseIndex(caseId) {
      const array = this.tableData || [];
      var caseIndex = null;
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        if (element.id === caseId) {
          caseIndex = index;
          break;
        }
      }
      return caseIndex;
    },

    async back(caseId) {
      const caseIndex = this.getCaseIndex(caseId);
      if (caseIndex !== null && caseIndex > 0 && caseIndex < this.tableData.length) {
        this.onDetail(this.tableData[caseIndex - 1]);
      } else if (caseIndex === 0) {
        if (this.pagination.current > 1) {
          // 如果是第一页面
          this.pagination.current = this.pagination.current - 1;
          await this.getCaseList();
          setTimeout(() => {
            this.onDetail(this.tableData[this.tableData.length - 1]);
          }, 100);
        } else {
          console.log('已经是第一页了，别翻了');
        }
      }
    },

    // 添加用例
    onAdd() {
      this.$nextTick(() => {
        this.$refs.caseDrawerRef.onOpen(null, 'create');
      });
    },

    // 编辑用例
    onEdit(record) {
      this.$nextTick(() => {
        var isFirst = false;
        var isEnd = false;
        if (record) {
          const caseIndex = this.getCaseIndex(record.id);
          if (this.pagination.current === 1 && caseIndex === 0) {
            isFirst = true;
          }
          if (this.pagination.current === this.pageTotal && caseIndex === this.tableData.length - 1) {
            isEnd = true;
          }
        }
        this.$refs.caseDrawerRef.onOpen(record.id, 'edit', isFirst, isEnd);
      });
    },

    // 查看用例详情
    onDetail(record) {
      this.$nextTick(() => {
        var isFirst = false;
        var isEnd = false;
        if (record) {
          const caseIndex = this.getCaseIndex(record.id);
          if (this.pagination.current === 1 && caseIndex === 0) {
            isFirst = true;
          }
          if (this.pagination.current === this.pageTotal && caseIndex === this.tableData.length - 1) {
            isEnd = true;
          }
        }
        this.$refs.caseDrawerRef.onOpen(record.id, 'view', isFirst, isEnd);
      });
    },

    // 关闭回调
    close() {
      this.caseId = null;
      this.caseData = {};
      this.editVisible = false;
      this.detailVisible = false;
      this.getCaseList();
    },

    // 表格页面参数变更回调方法
    handleTableChange(pagination, _, sorter) {
      this.pagination = pagination;
      this.sorter.sort_field = sorter.field;
      this.sorter.sort = sorter.order === 'ascend' ? 'asc' : 'desc';
      this.getCaseList();
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .customer-filter {
  .ant-page-header {
    padding: 0;
  }

  margin-bottom: 16px;

  .ant-form-item {
    margin-bottom: 8px;
    display: flex;

    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }

  .filter-right {
    float: right;
    text-align: right;
  }

  .customer-date-picker {
    width: calc(50% - 3px);
  }
}

/deep/ .ant-table-tbody > tr > td {
  padding: 8px 8px;
}

/deep/.ant-table-thead > tr > th {
  padding: 8px 8px;
}

.handle-menu {
  margin: 0 4px;
}

.custom-link {
  color: rgba(0, 0, 0, 0.65);
}

.custom-link:hover {
  color: #1890ff;
}

.handle-button {
  margin-left: 8px;
}
</style>
